import script from "./ExtendOneToOneDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExtendOneToOneDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ExtendOneToOneDialog.vue?vue&type=style&index=0&id=27d99274&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27d99274"]])

export default __exports__